import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHFeriadoSerieGet = async (credentials, data) => {
  const body = {
    service: "RNHFeriadoSerieGet",
    params: {
      rnhFeriadoSerieId: data?.id || null,
      fechaDesde: data?.desde || null,
      fechaHasta: data?.hasta || null,
      rnhFeriadoTipo: data?.tipo || null,
    },
  };
  return respuestaDe(await axiosPost(body, credentials));

};
